import { render, staticRenderFns } from "./ToPayBankTransferSection.vue?vue&type=template&id=6c2f2c74&scoped=true&"
import script from "./ToPayBankTransferSection.vue?vue&type=script&lang=js&"
export * from "./ToPayBankTransferSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f2c74",
  null
  
)

export default component.exports